// Outlet colour coding — the small coloured label shown on an outlet
// (e.g. a red "No order in 90 days"). Renders nothing when the outlet has
// no colour, so callers can drop it in unconditionally.
import { cleanTag } from "@/lib/outletColors";

export default function OutletColorChip({ tag, className = "", testid }) {
  const t = cleanTag(tag);
  if (!t) return null;
  const c = t.color;
  return (
    <span
      className={"inline-flex max-w-full items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-semibold leading-tight " + className}
      style={{ backgroundColor: `${c}1F`, color: c }}
      title={t.name}
      data-testid={testid}
    >
      <span className="h-1.5 w-1.5 shrink-0 rounded-full" style={{ backgroundColor: c }} />
      <span className="min-w-0 truncate">{t.name}</span>
    </span>
  );
}
